import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import { toast } from "react-toastify";
import Navbar from "../components/Navbar";

Modal.setAppElement("#root");

export default function Reports(props) {
  const [forms, setForms] = useState(props.forms);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formToDelete, setFormToDelete] = useState(null);

  const handleDelete = async (formId) => {
    try {
      const response = await fetch(`/forms/${formId}`, {
        method: "DELETE",
      });
      if (response.ok) {
        setForms(forms.filter((form) => form.id !== formId));
        setIsModalOpen(false);
        toast.success("Форма успешно удалена!");
      } else {
        toast.error("Ошибка при удалении формы.");
      }
    } catch (error) {
      console.error("Ошибка при запросе", error);
      toast.error("Произошла ошибка при запросе.");
    }
  };

  const openDeleteModal = (formId) => {
    setFormToDelete(formId);
    setIsModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setFormToDelete(null);
  };

  const getFormType = (type) => {
    switch (type) {
      case "main_report":
        return "Отчет";
      case "summary_report":
        return "Сводный отчет";
      default:
        return type;
    }
  };

  return (
    <div className="min-h-full bg-gray-50">
      <div className="pb-32">
        <Navbar props={props} />

        {/* Заголовок */}
        <header className="py-12">
          <div className="mx-auto container max-w-screen-2xl px-4">
            <h1 className="text-3xl font-semibold tracking-tight text-black">
              Отчеты
            </h1>
          </div>
        </header>
      </div>

      {/* Основной контент */}
      <main className="-mt-32">
        <div className="mx-auto container max-w-screen-2xl px-4 pb-12">
          <div className="overflow-hidden rounded-lg border border-gray-300 shadow-md overflow-x-auto">
            <table className="  w-full border-collapse bg-white text-left text-sm text-gray-700">
              <thead className="bg-gradient-to-r from-blue-700 to-blue-800 text-white">
                <tr>
                  <th className="px-6 py-4 font-medium">Название формы</th>
                  <th className="px-6 py-4 font-medium">Тип формы</th>
                  <th className="px-6 py-4 font-medium">Видима?</th>
                  <th className="px-6 py-4 font-medium">Отменена?</th>
                  <th className="px-6 py-4 font-medium text-right">Действия</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 border-t border-gray-200">
                {forms.map((form) => (
                  <tr key={form.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 font-medium text-gray-900">
                      {form.short_name}
                    </td>
                    <td className="px-6 py-4 text-gray-500">
                      {getFormType(form.form_type)}
                    </td>
                    <td className="px-6 py-4 text-gray-500">
                      {form.is_visible ? "Да" : "Нет"}
                    </td>
                    <td className="px-6 py-4 text-gray-500">
                      {form.canceled ? "Да" : "Нет"}
                    </td>
                    <td className="px-6 py-4 text-right">
                      <button
                        className="text-blue-600 hover:text-blue-800 mr-4"
                        onClick={() =>
                          (window.location.href = `/forms/${form.id}/edit`)
                        }
                      >
                        <FontAwesomeIcon icon={faPenToSquare} size="lg" />
                      </button>
                      <button
                        className="text-red-600 hover:text-red-800"
                        onClick={() => openDeleteModal(form.id)}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} size="lg" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-1/3">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Вы уверены, что хотите удалить эту форму?
            </h2>
            <div className="flex justify-end gap-4">
              <button
                onClick={closeDeleteModal}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
              >
                Отмена
              </button>
              <button
                onClick={() => handleDelete(formToDelete)}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
